import React, { createContext, useContext, useEffect, useState } from "react";

const LiveUpdateContext = createContext();

export function useLiveUpdate() {
  return useContext(LiveUpdateContext);
}

export function LiveUpdateProvider({ children }) {
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const clearNotifications = () => {
    setNotifications([]);
    setUnreadCount(0);
  };

  useEffect(() => {
    // Check both environment variables to ensure compatibility
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 
                      (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace(/\/api$/, '') : "http://localhost:8080");
    const API_URL = `${backendUrl}/api`;
    
    // Connect to the SSE stream
    // EventSource doesn't automatically pass cross-origin cookies in all browsers unless configured
    // So we can pass token via query param if needed, or rely on withCredentials
    
    // Get cookies
    const cookies = document.cookie.split(';');
    let sessionToken = '';
    let accessToken = '';
    
    cookies.forEach(cookie => {
      const [name, value] = cookie.trim().split('=');
      if (name === 'session_token') sessionToken = value;
      if (name === 'access_token') accessToken = value;
    });

    let streamUrl = `${API_URL}/stream`;
    if (sessionToken) {
      streamUrl += `?session_token=${sessionToken}`;
    } else if (accessToken) {
      streamUrl += `?access_token=${accessToken}`;
    }

    const eventSource = new EventSource(streamUrl, {
      withCredentials: true,
    });

    eventSource.onmessage = (event) => {
      try {
        const payload = JSON.parse(event.data);
        if (payload.type === "update") {
          setUpdateTrigger((prev) => prev + 1);
        } else if (payload.type === "notification") {
          // Check if notification is meant for the current user
          const userId = localStorage.getItem('userId');
          if (payload.data && String(payload.data.user_id) === userId) {
            setNotifications((prev) => [payload.data, ...prev]);
            setUnreadCount((prev) => prev + 1);
          }
        }
      } catch (err) {
        // Fallback for older string messages
        if (event.data === "update") {
          setUpdateTrigger((prev) => prev + 1);
        }
      }
    };

    eventSource.onerror = (error) => {
      console.error("SSE Error:", error);
      // EventSource auto-reconnects by default, but we can close it if needed
      // eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, []);

  return (
    <LiveUpdateContext.Provider value={{ 
      updateTrigger, 
      notifications, 
      unreadCount, 
      clearNotifications 
    }}>
      {children}
    </LiveUpdateContext.Provider>
  );
}
